import React from 'react';
import Icon from 'components/icon/icon'

const ListHeading = props => {
    const {
        columns,
        sortingData,
        setSorting,
        isVisible
    } = props

    let headingClassName = 'list-heading'

    if(isVisible){
        headingClassName += ' visible'
    }

    return (
        <div className={headingClassName}>
            <ul>
            { columns.map(column => {
                let sortingDirection = null

                if(sortingData.column == column.slug){
                    sortingDirection = sortingData.direction
                }

                return (
                    <li
                        key={column.slug}
                        className={sortingDirection ? 'sorting sort-'+sortingDirection : null}
                    >
                        <button
                            onClick={_ => {
                                setSorting(column.slug)
                            }}
                        >
                            { column.label }
                            { sortingDirection && 
                                <Icon
                                    name={'caret-up'}
                                />
                            }
                        </button>
                    </li>
                )
            }) }
            </ul>
        </div>
    )
};

export default ListHeading;
